<template>
</template>

<script>
export default {
    props: [
        'items'
    ]
};
</script>



// WEBPACK FOOTER //
// src/pages/widgets/Breadcrumb.vue